import FetchApi from "../util/fetchApi";
const fetchApi = new FetchApi();

const DATA_WAREHOUSE_CONNECTION_TYPE = 1;
const DATA_ANALYTICE_CONNECTION_TYPE = 3;
const MACHINE_LEARNING_CONNECTION_TYPE = 7;

export default class UserConnection {
  async getDataWarehouseConnection() {
    return (await fetchApi.get(`/userconnection/${DATA_WAREHOUSE_CONNECTION_TYPE}`)).data;
  }

  async getMachineLearningConnection() {
    return (await fetchApi.get(`/userconnection/${MACHINE_LEARNING_CONNECTION_TYPE}`)).data;
  }

  async updatePassword(Type_id, postData) {
    return (await fetchApi.post(`/userconnection/${Type_id}`, postData)).data;
  }

  async connectDataAnalytic() {
    return (await fetchApi.post(`/userconnection/connect/${DATA_ANALYTICE_CONNECTION_TYPE}`)).data;
  }

  async connectMachineLearning(postData) {
    return (await fetchApi.post(`/userconnection/connect/${MACHINE_LEARNING_CONNECTION_TYPE}`, postData)).data;
  }
}
